import { useLocalSearchParams } from 'expo-router';

import { SelectAccount as AccountSelector } from '../../../../banking/components/direct-deposit/SelectAccount';
import type { DirectDepositSwitchAppContext } from '../../../../banking/components/direct-deposit/types';

const SelectAccount = () => {
    const { bankAccountId, context, source } = useLocalSearchParams<{
        bankAccountId?: string;
        context?: DirectDepositSwitchAppContext;
        source?: string;
    }>();
    return (
        <AccountSelector
            defaultBankAccountId={bankAccountId}
            context={context}
            source={source}
        />
    );
};

export default SelectAccount;
